<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Base Corredores</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          <div>
            <b-row class="mb-3">
              <b-col sm = "2">
                <label>Corredor</label>
              </b-col>  
              <b-col sm = "2">
                <b-form  @submit.prevent="consulta_corredor()" > 
                  <b-input-group @submit.prevent="consulta_corredor()">
                    <b-form-input type="text" v-model="datosFormulario.codCorredor"/>
                    <b-input-group-prepend class="input-group-append">
                        <b-button type="submit" class="fa fa-search" variant="primary"></b-button>
                    </b-input-group-prepend>
                  </b-input-group>
                </b-form>
              </b-col>
              <b-col sm = "2">
                <b-input-group>
                  <b-form-input type="text" v-model="datosFormulario.IdNacionCorred"/>
                </b-input-group>
              </b-col>
              <b-col sm="4">
                <b-input-group>
                  <b-form-input type="text" v-model="datosFormulario.NombreCorred"/>
                </b-input-group>
              </b-col>
            </b-row>

          </div>
          <div slot="footer">
                <div class="form-actions text-right">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="buscar"><i class="fa fa-search"></i> Consultar</b-button>
                                <b-button variant="primary" @click="pre_insertar" style="margin-left: 10px;"><i class="fa fa-eraser"></i> Limpiar</b-button>
                                <b-button variant="primary" @click="descargarExcel" style="margin-left: 10px;"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                            </el-col> 
                    </el-row>                
                </div>
            </div>            
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Base Corredores</strong>
          </div>
          <b-row>
            <b-col lg="6">
              <b-button v-if="hasCorredor" variant="primary" @click="nuevoContacto()">Agregar Contacto</b-button>
            </b-col>  
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">             
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :min-width="title.minwidth" 
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                
                <el-table-column label="" min-width="200px" align="center">
                <template slot-scope="scope">
                    <el-button
                          size="mini"
                          type="primary"
                          @click="button.handler"
                          v-for="button in customButtonsForRow(scope.row)"
                          :key="button.id"
                        >
                          {{ button.name }}
                    </el-button>
                  </template>
                </el-table-column>

              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

      </b-col>
    </b-row>

  <b-modal
      id="modificacion-contacto"
      title="Modificación Contacto"
      scrollable
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      size="lg"
      v-model="modalModificar"
      @ok="handleOk"
      @cancel="modalModificar = false"
    >
    <b-form ref="form" @submit.stop.prevent="handleSubmit">
      <b-row class="my-1">
        <b-col sm="4">
          <label>Nombre Corredor</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.corredor">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Nombre Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.contacto">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Mail Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group
            invalid-feedback="La dirección de correo electrónico no incluye un signo @"
            :state="nameState">
              <b-form-input 
                  type="email" 
                  v-model="datosFormularioModal.mail"
                  required
                  :state="nameState">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

       <b-row class="my-1">
        <b-col sm="4">
          <label>Tipo de correos</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox-group
                v-model="datosFormularioModal.procesos"
                :options="procesos"
              ></b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Última Modificación</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.femodif">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Usuario</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.usumodif">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
    </b-modal>

    <!-- Agregar Contacto -->
    <b-modal
      id="nuevo-contacto"
      title="Nuevo Contacto"
      scrollable
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      size="lg"
      v-model="modalNuevo"
      @ok="handleOk"
      @cancel="modalNuevo = false"
    >
    
    <b-form ref="form" @submit.stop.prevent="handleSubmit">
      <b-row class="my-1">
        <b-col sm="4">
          <label>Nombre Corredor</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.corredor">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Nombre Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.contacto">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Mail Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group
            invalid-feedback="La dirección de correo electrónico no incluye un signo @"
            :state="nameState"
            >
              <b-form-input 
                  type="email" 
                  v-model="datosFormularioModal.mail"
                  required
                  :state="nameState">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Tipo de correos</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox-group
                v-model="datosFormularioModal.procesos"
                :options="procesos"
                
              ></b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
    </b-modal>
  
    <!-- Eliminar -->
    <b-modal
      title="Eliminar Contacto"
      cancel-title="Cancelar"
      ok-title="Eliminar"
      class="modal-success"
      v-model="modalEliminar"
      @ok="eliminarGuardar();"
      @cancel="modalEliminar = false"
    >
        Se eliminará el siguiente contacto:
        <br><br>
        Corredor: {{datosFormularioModal.corredor}} 
        <br>
        Contacto: {{datosFormularioModal.contacto}} 
    
    </b-modal>
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiBaseCorredor from "@/components/services/apiBaseCorredor";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';

import XLSX from "xlsx";

export default {
  name: "BaseAsegurado",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      modalModificar : false,
      modalEliminar : false,
      modalNuevo : false,
      hasCorredor : false,
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },
      selectedCor: [],
      selectedDire:[],
      nameState: null,
      submittedNames: [],

      ckdDire: [
          { item:  'DL', name: 'Dirección Legal' },
          { item:  'DP', name: 'Dirección Particular' }
        ],
      
      chkDireccion:false,

      data: [],
      nombreexcel: "BaseCorredores",
      titles: [
        {
          prop: "corredor",
          label: "Corredor",
          align: "left",
          minwidth:'250'
        },
        {
          prop: "contacto",
          label: "Nombre Contacto",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "mail",
          label: "Email Contacto",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "actual",
          label: "Actual",
          align: "center",
          minwidth:'120'
        }
       
        
      ],
      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      datosFormularioModal: {
          idcontacto: "",
          corredor: "",
          contacto: "",
          mail: "",
          femodif: "",
          usumodif: "",
      },
      
      mostrarFechas: true,
      datosFormulario: {
          IdNacionCorred: "",
          NombreCorred: "",
          codCorredor: "",
      },

      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},
      
      valEjecutivos: [],
      procesos: [],

      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        // rowKey: "id"
      },
    };
  },
  components:{
    Datepicker,
    Multiselect
  },
  methods: {
    customButtonsForRow(row) {
          var botones = new Array();
          
          var obj = new Object();
          obj.tooltip = "Selec. Correo";
          obj.id = 1;
          obj.name="Selec. Correo";
          obj.icon = "fa fa-pencil-square-o";
          obj.type = "success";
          obj.handler= _ => {
              this.$session.start();
              this.recuperar_DatConCorr(row);
          }
          botones.push(obj);
          
          var obj2 = new Object();
          obj2.tooltip = "Eliminar";
          obj2.id = 2;
          obj2.name="Eliminar";
          obj2.icon = "fa fa-eraser";
          obj2.type = "success";
          obj2.handler= _ => {
              this.$session.start();
              this.eliminarContacto(row);
          }
          botones.push(obj2);
          
          return botones;

    },

    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },

    cambiarFechas(){
      if(this.datosFormulario.selected == 'A') {
            this.mostrarFechas = false;
      }else{
            this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format();
             
          } else {
              sums[index] = '';
          }
      });

      return sums;
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },

    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.text = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor].toString();
            obj.text = data[i][texto];
          }
          arr.push(obj);
        }
        return arr;
    },
    
    pre_insertar() {
      this.$Progress.start(); 
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;
  
      this.datosFormulario.codCorredor ="";
      this.datosFormulario.IdNacionCorred ="";
      this.datosFormulario.NombreCorred ="";
      this.hasCorredor = false;
      

      return apiBaseCorredor
        .pre_insercion_corredor(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }

          this.datosFormulario.codCorredor='';

          //  carga de listados
         this.procesos = this.llenaArrayLista(response.data.procesos, 'codigo', 'nombre', false);
          
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });
    },

    buscar() {
      this.$Progress.start();
      var p_email= this.$session.get("mail");

      this.datosFormulario.codCorredor == '' ? '': this.datosFormulario.codCorredor;
      
      var p_corredor = this.datosFormulario.codCorredor == ''? '0' : this.datosFormulario.codCorredor;

      return apiBaseCorredor
      .recuperar_ConCorr(p_email, p_corredor)
          .then( (response)=>{

            response.data = this.keysMinuscula(response.data); 
            this.data = response.data.res;
            this.$Progress.finish();
        })
        .catch((error)=>{
          this.$Progress.finish();
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
        });
    },

    formatter(row, column) {
      if ((column.property == "femodif"
          ) && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      } else {
        return row[column.property];
      }
    },
    
    descargarExcel: function () {
      var cuerpo = "";
      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      
      ///COLUMNAS ESCRIBIR
      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      //for (var i = 0; i < columnas.length; i++) {
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Nombre Corredor" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Código Corredor" + "</td>\n";     
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Nombre Contacto" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Mail Contacto" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Actual" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Última Modificación" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Usuario" + "</td>\n";

        
      //}
      cuerpo += "</tr>\n";
      
      //Data bloque 1
      let diadiapol = '';
      let decididor = '';
      
      for (var key in this.data) {
        if(this.data[key]["contacto"] === undefined){ 
          this.data[key]["contacto"] = "";
        }
        if(this.data[key]["mail"] === undefined){ 
          this.data[key]["mail"] = "";
        }
         if(this.data[key]["actual"] === undefined){ 
          this.data[key]["actual"] = "";
        }
        if(this.data[key]["femodif"] == undefined){ 
          this.data[key]["femodif"] = "";
        }
        if(this.data[key]["usumodif"] == undefined){ 
          this.data[key]["usumodif"] = "";
        }
      
        
        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["corredor"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["codcorredor"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["contacto"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["mail"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["actual"] + "</td>\n";
       
        cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + this.data[key]["femodif"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["usumodif"] + "</td>\n";
        
        
        cuerpo += "</tr>\n";
      }

      //Data bloque 1
      
      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },


    consulta_corredor: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      this.hasCorredor = false;
      var p_corredor = this.datosFormulario.codCorredor == '' ? '0': this.datosFormulario.codCorredor;
      var p_email = this.$session.get("mail");
      
      if ((p_corredor==0) || (p_corredor=="")){
          this.datosFormulario.NombreCorred ="";
          this.mensaje= "Ingrese SR Corredor.";
          this.variant="warning";
          this.showAlert();
          return false;
      }
      return apiBaseCorredor
        .consulta_corredor(
          p_email, p_corredor
        ).then((response) => {
         
         response.data = this.keysMinuscula(response.data);
         var InfoCorredor = response.data.res;
         var InfoCorredorDir = response.data.res1;
         for (var i = 0; i < InfoCorredor.length; i++) {
            this.datosFormulario.IdNacionCorred = InfoCorredor[i]["peridnacion"];
            this.datosFormulario.NombreCorred = InfoCorredor[i]["pernombreimp"];
          }
          this.hasCorredor = true;
        this.$Progress.finish();
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },

    nuevoContacto: function(){
      this.datosFormularioModal.corredor = this.datosFormulario.NombreCorred;
      this.datosFormularioModal.codCorredor = this.datosFormulario.codCorredor;  
  
      this.datosFormularioModal.contacto = "";
      this.datosFormularioModal.mail = "";
 
      this.modalNuevo = true;
    },

recuperar_DatConCorr: function( row ) {
      this.$Progress.start(); 
      var filtrados = this.procesos;

       const names = filtrados.map(el => el.value);
       var marcados = new Array();

      return apiBaseCorredor
        .recuperar_DatConCorr(
          this.$session.get("mail"),
          row.idcontacto
        )  
        .then(response => {
                  
          if (response.data != undefined){
            response.data = this.keysMinuscula(response.data);
            var DatoConCorr = response.data.res[0];
              this.datosFormularioModal.idcontacto = DatoConCorr.idcontacto;
              this.datosFormularioModal.corredor = DatoConCorr.corredor;
              this.datosFormularioModal.contacto = DatoConCorr.contacto;
              this.datosFormularioModal.mail = DatoConCorr.mail;
              this.datosFormularioModal.usumodif = DatoConCorr.usumodif;
              this.datosFormularioModal.femodif = DatoConCorr.femodif;
            }
            
          response.data = this.keysMinuscula(response.data);
          var DatoProceso = response.data.procesos;

        for (var index = 0; index < DatoProceso.length; ++index) {

          if (names.includes(DatoProceso[index]["codigo"] + '')){
            marcados.push(DatoProceso[index]["codigo"]);
          }
      }

          this.datosFormularioModal.procesos = marcados;

          this.modalModificar = true;
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });
    },

    intersection(o1, o2) {
    return Object.keys(o1).concat(Object.keys(o2)).sort().reduce(function (r, a, i, aa) {
        if (i && aa[i - 1] === a) {
            r.push(o1[a].value);
        }
         return r;
    }, []);
    },

    checkFormValidity() {
        const valid = this.$refs.form.checkValidity()
        this.nameState = valid
        return valid
      },
      resetModal() {
        this.name = ''
        this.nameState = null
      },


      handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault();  
        // Trigger submit handler
        this.handleSubmit();
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return;
        }
        // Push the name to submitted names
        this.submittedNames.push(this.datosFormularioModal)
        // Hide the modal manually
        this.$nextTick(() => {
          this.saveRow();
          this.$bvModal.hide('modificacion-contacto');
          this.$bvModal.hide('nuevo-contacto');

        })
      },

      saveRow() { 
     
      let rows = this.datosFormularioModal;
      var p_id = rows.idcontacto;
      var tpprocesosv = "";
      var tpprocesos = this.datosFormularioModal.procesos;

      for (var i = 0; i < tpprocesos.length; i++) {
        tpprocesosv  += tpprocesos[i] + ',';
            
      }
      tpprocesosv = tpprocesosv.slice(0, -1);
      
      if ((parseInt(p_id)>0) && (this.modalModificar)){
        //Modificar
        return apiBaseCorredor
          .editar_ConCorr(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            rows.idcontacto,
            rows.contacto,
            tpprocesosv,
            rows.mail
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Editar",
                "Se ha editado el contacto.",
                "success"
              );
            }
            else{
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          }
          )
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });        
      }else{
        return apiBaseCorredor  
          .insertar_ConCorr(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            rows.codCorredor,
            rows.contacto,
            tpprocesosv,
            rows.mail
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Insertar",
                "Se ha guardado el nuevo contacto.",
                "success"
              );
            }
            else{

              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });
      }
    },
    
    eliminarContacto(row){
      this.datosFormularioModal.codCorredor = row.codCorredor;
      this.datosFormularioModal.corredor = row.corredor;
      this.datosFormularioModal.contacto = row.contacto;
      this.datosFormularioModal.idcontacto = row.idcontacto;
      this.modalEliminar = true;
    },

    eliminarGuardar(){
      return apiBaseCorredor
          .eliminar_ConCorr(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datosFormularioModal.idcontacto
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Eliminar",
                "Se ha eliminado el contacto.",
                "success"
              );
            }
            else{
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });
    }
  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();  
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>
